import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  CardBody,
  CardHeader,
  CardIcon,
} from '~/components/Card';
import PF2MDataTable from '~/components/PF2MDataTable';
import { searchEditHistory } from '~/store/editlogs/actions';
import { getWebUsers } from '~/store/manager/actions';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';


const TABLE_NAME_MAPPER = {
  transportList: 'transport_report',
  loadList: 'load_report',
  perforatorList: 'perforator_report',
  refuelerList: 'refueler_report',
  codesRawList: 'codes_raw_report',
  hourmeterList: 'hourmeter_report',
  tractorList: 'tractor_report',
  infrastructureList: 'infrastructure_report',
  shaftList: 'shaft_report',
  fillinList: 'fillin_report',
  railRoadList: 'railroad_report',
  scissorLiftList: 'scissor_lift_report',
  activityList: 'activity_report',
  hourMachineList: 'hour_machine_report',
  anomalyLogList: 'anomaly_log',
};


const EditHistoryModal = ({
  idName,
  referenceColumns,
  listName,
  selectedEditHistoryData,
  customEditHistoryColumns,
  handleClose,
}) => {
  const { t: translate } = useTranslation();
  const ehTranslation = translate('common:EditHistory');

  const dispatch = useDispatch();
  const [dataLoaded, setDataLoaded] = useState(false);

  const editHistoryData = useSelector(state => state.editlogs.editHistory);
  const webUsers = useSelector(state => state.manager.webUsers);

  useEffect(() => {
    const loadData = () => {
      dispatch(getWebUsers());
      dispatch(searchEditHistory({
        historyId: selectedEditHistoryData[idName],
        tableName: TABLE_NAME_MAPPER[`${listName}List`],
      }));
      setDataLoaded(true);
    };

    if (!dataLoaded && selectedEditHistoryData[idName] !== null) {
      loadData();
    }
  }, [editHistoryData]);

  const data = editHistoryData.map(({ content, ...ehd }) => ({
    editId: ehd.id,
    editWebUserId: ehd.web_user_id,
    editTimestamp: ehd.timestamp * 1000,
    ...content,
    id: content[idName] ?? content.id,
  }));

  const defaultColumns = [
    {
      editable: 'never',
      customType: 'dateTimeByTimestamp',
      title: translate('common:EditHistoryDatetime'),
      field: 'editTimestamp',
    },
    {
      editable: 'never',
      customType: 'filterLookup',
      title: translate('common:Editor'),
      field: 'editWebUserId',
      lookup: webUsers.map(wu => ({ id: wu.id, name: wu.username })),
    },
  ];

  const columns = referenceColumns
    .map((col) => {
      const foundCustomColumn = customEditHistoryColumns.find(
        c => c.title === col.title,
      );
      return foundCustomColumn !== undefined ? foundCustomColumn : col;
    })
    .filter(col => col.title !== ehTranslation || col.field !== 'edit_history')
    .map(col => ({ editable: 'never', ...col }));

  return (
    <div
      style={{
        width: '92vw',
      }}
    >
      <Card>
        <CardHeader icon>
          <div>
            <CardIcon color="warning">
              <LocalShippingIcon />
            </CardIcon>
            <CardIcon
              onClick={handleClose}
              style={{
                float: 'right',
                cursor: 'pointer',
                background: 'darkgray',
                borderRadius: 50,
                boxShadow: '10px 10px 50px gray',
              }}
            >
              <CloseIcon />
            </CardIcon>
          </div>
        </CardHeader>
        <CardBody>
          <p style={{
            color: 'black',
            textAlign: 'center',
            fontSize: '28px',
            fontWeight: 'bolder',
          }}
          >
            {ehTranslation}
          </p>
          <PF2MDataTable
            options={{
              cellEditable: false,
              hideCommit: true,
              hideReload: true,
              hideAdd: true,
            }}
            title={ehTranslation}
            columns={[...defaultColumns, ...columns]}
            isEditable={() => false}
            defaultEditable={false}
            data={data}
          />
        </CardBody>
      </Card>
    </div>
  );
};

EditHistoryModal.propTypes = {
  idName: PropTypes.string,
  referenceColumns: PropTypes.arrayOf(PropTypes.object).isRequired,
  customEditHistoryColumns: PropTypes.arrayOf(PropTypes.object),
  listName: PropTypes.string.isRequired,
  selectedEditHistoryData: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
};

EditHistoryModal.defaultProps = {
  idName: 'id',
  customEditHistoryColumns: [],
};

export default EditHistoryModal;
